import { Nominal } from "@common/domain";

export abstract class BaseRequestDTO<T> extends Nominal<T> {
  constructor(readonly value: T) {
    super();
  }

  abstract toJSON(): object;
}
